<template>
  <div class="flex items-center justify-center h-full">
    <h1>Virtua - Página Carregada</h1>
    <p>{{ testMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'ModulosVirtua',
  data() {
    return {
      testMessage: 'Funcionando!',
    };
  },
};
</script>